// extracted by mini-css-extract-plugin
module.exports = {"eventLog":"EventLog_eventLog__1RNY0","innerCard":"EventLog_innerCard__2nBER"};